/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/bubble-shape': {
    width: 23,
    height: 43,
    viewBox: '0 0 23 43',
    data: '<path pid="0" d="M.695.84v41.836l20.197-27.41 1.923-5.29L.695.84z" _fill="#fff"/>'
  }
})
